











import { Component, Prop, Vue } from 'vue-property-decorator';
import VerticalAligned from '@/components/VerticalAligned.vue';

export interface TopBannerBackground {
    background:               string;
    backgroundMobile:         string;
}

@Component(
  {
    components: { VerticalAligned }
  }
)
export default class TopBanner extends Vue {
  @Prop() private background!: string;
  @Prop() private backgroundMobile!: string;
  @Prop() private height!: string;
  @Prop() private heightMobile!: string;

  getAssetPath(image:string):string {
      let images = require.context('../assets/', true, /\.jpg$/);
      return images(image);
  }
}
